import api from "../api/axios";

const dashboardService = {
  getStats: () => api.get("dashboard/get-stats"),
};

export default dashboardService;
